const colors = {
  gray1: '#2e2d37',
  gray2: '#696977',
  gray3: '#AEAEBA',
  gray5: '#ECEDF2',
  grayBg: '#f3f5f8',
  grayLight: '#aeaeae',
  primary1: '#f3123c',
};

export { colors };
